<div class="rounded-2.5xl w-full">
  <!-- Header -->
  <div
    class="flex md:flex-row flex-col justify-around items-center px-12 py-6 md:py-4 border-gray-300 border-b">
    <h1 class="text-gray-500 text-xl md:text-3xl" [innerHTML]="title()"></h1>
    <h3 class="bg-main mt-2 md:mt-0 px-4 py-1 rounded-xl text-white text-sm">
      Section: {{ seatSection }} &nbsp; Row: {{ seatRow }} &nbsp; Seat:
      {{ seat }}
    </h3>
  </div>
  <!-- <hr> -->
  <!-- Body -->
  <div class="px-12 md:px-14 py-6 md:py-4">
    <h4 class="text-gray-500">Information about the seat:</h4>
    <ul
      class="mt-2 font-poppins font-medium text-gray-800 text-base"
      style="list-style-type: disc; padding-left: 20px">
      @for (item of definitions(); track item.id) {
        <li class="[&:not(:last-child)]:my-2">
          {{ item.description }}
        </li>
      }
      @if (isAda()) {
        <li>The seat is ADA.</li>
      }
    </ul>
    <div class="flex justify-center mt-6 md:mt-12">
      <sdc-button
        class="gs-modal-btn--primary"
        className="disabled:opacity-30 !w-28 min-w-max h-10 disabled:hover:transform-none hover:scale-95 transition-transform"
        theme="theme-sdc"
        variant="primary"
        (onClick)="close()">
        Close
      </sdc-button>
    </div>
  </div>
</div>
